import { convertServerTimeToLocal } from "@whoosh/utilities/src/dates";

export const getServerTimeOffsetMs = (
  currentServerTime: string | null | undefined
) => {
  if (!currentServerTime) {
    return null;
  }

  return convertServerTimeToLocal(currentServerTime).getTime() - Date.now();
};

export const getLiftAtForServerTimeOffset = (
  liftAt?: string | null,
  serverTimeOffsetMs?: number | null
) => {
  if (!liftAt) {
    return null;
  }

  if (!serverTimeOffsetMs) {
    return liftAt;
  }

  const liftAtMs = convertServerTimeToLocal(liftAt).getTime();

  return new Date(liftAtMs - serverTimeOffsetMs).toISOString();
};
